import { useTranslation } from 'react-i18next'
import Rating from '@/shared/components/Rating/Rating'
import styles from './FeedbackSummary.module.scss'

/**
 * The average of what guests gave, as one number.
 *
 * It listed food, service and ambiance separately until the guest form settled
 * on a single rating of the visit. Three averages over one question would have
 * been the same number printed three times.
 */
function FeedbackSummary() {
  const { t } = useTranslation()

  return (
    <div className={`${styles.feedbackSummaryWrapper}`}>
      <div className={styles.feedbackSummaryList}>
        <div className={styles.feedbackSummaryItem}>
          <p className={`${styles.feedbackSummaryItemLabel} title-medium`}>
            {t('FEEDBACK.OVERALL')}
          </p>
          <div className={styles.ratingContainer}>
            <Rating defaultValue={4.2} isReadOnly />
            <p className={`${styles.feedbackSummaryItemValue} title-medium`}>
              4.2 / 5
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeedbackSummary
